import PropTypes from "prop-types";

export const GridItems = ({ children }) => {
  return <div className="home-grid">{children}</div>;
};

GridItems.propTypes = {
  children: PropTypes.node.isRequired,
};
